import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class LoanPartType extends Entity<LoanPartType> {
    @Expose()
    name!: string

    @Expose()
    label!: string
}
